import React from 'react';
import SalesMaterialsSection from './SalesMaterialsSection';

/** Resources tab on /portal/sales — the CRM-managed Sales Materials collections. */
const SalesResourcesTab = () => <SalesMaterialsSection standalone />;

export default SalesResourcesTab;
